<!-- title -->
<app-modal-title
  [title]="'pages.contacts.deleteContactsFormPhonebooks.title' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <p class="tw-mt-5 tw-mb-0 tw-flex tw-justify-between tw-items-center">
    <span class="tw-text-base tw-font-normal">
      <span class="text-danger">*</span>
      {{ "pages.contacts.deleteContactsFormPhonebooks.message" | translate }}
      <a
        class="btn btn-sm tw-font-medium"
        (click)="onSelectCurrentGroup()"
        [themeColor]="'btn-light-info'"
      >
        {{
          "pages.contacts.deleteContactsFormPhonebooks.selectCurrentGroup"
            | translate
        }}
      </a>
    </span>
  </p>

  <!-- form -->
  <form [formGroup]="form">
    <div class="row">
      <div class="md:tw-w-full tw-mt-5">
        <phonebook-selection-list
          type="phonebooksByContactId"
          [id]="contactId"
          searchLabel="messages.searchInPhonebooks"
          [values]="phonebooks"
          (values)="phonebooks = $event; log($event)"
          searchBoxGridClass="sm:tw-w-1/2 xl:tw-w-2/3"
          responsiveClass="sm:tw-w-1/2 xl:tw-w-1/3"
        >
        </phonebook-selection-list>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
      [isDisabled]="phonebooks?.length ? false : true"
      submitBgColor="danger"
      closeBgColor="light-dark"
      customTitle="common.delete"
    >
    </app-form-btns>
  </form>
</div>
